import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

import Config from '../../../../core/config';

const InputField = (props) => {
  const {
    state,
    paymentName,
    paymentMethods,
    inputName,
    inputType,
    focusHandler,
    changeHandler,
    blurHandler,
    required,
    className,
    mask,
    placeholder,
    label,
    value,
    formTouched,
  } = props;
  const { bankCards } = Config.payment;
  const [isInputTouched, setIsTouched] = useState(formTouched);

  const maxLengthHandler = useMemo(function () {
    switch (inputName) {
      case 'number':
        return state.issuer.length > 0 && paymentMethods[state.issuer]
          ? paymentMethods[state.issuer].cardNumber.mask.length
          : 19;
      case 'name':
        return 32;
      case 'cvc':
        return state.issuer.length > 0 && paymentMethods[state.issuer]
          ? paymentMethods[state.issuer].cardCVV.mask.length
          : undefined;
      default:
        return undefined;
    }
  }, [inputName, state.issuer, paymentMethods]);

  const readOnlyHandler = useMemo(function () {
    switch (inputName) {
      case 'number':
        return paymentName === bankCards[0] && !state.issuer;
      case 'cvc':
        return !state.issuer;
      default:
        return false;
    }
  }, [inputName, state.issuer]);

  const isError = useMemo(function () {
    return state.requireFields.indexOf(inputName) >= 0
  }, [inputName, state.requireFields])

  const isValid = useMemo(function () {
    return state.validFields.indexOf(inputName) >= 0
  }, [inputName, state.validFields])

  const isTouched = useMemo(function () {
    return formTouched || isInputTouched
  }, [isInputTouched, formTouched])

  const onInputFocus = function (e) {
    if (focusHandler)
      focusHandler(e)
  }

  const onInputBlur = function (e) {
    setIsTouched(true)
    if (blurHandler)
      blurHandler(e)
  }

  const onInputChange = function (e) {
    // Run onInputAccept instead if mask exists
    if (mask) return;
    setIsTouched(false)
    if (changeHandler)
      changeHandler({value: e.target.value, name: inputName})
  }

  const onInputAccept = function (value, mask) {
    // Run onInputChange instead if mask doesn't exists
    if (!mask) return
    setIsTouched(false)
    if (changeHandler)
      changeHandler({value, name: inputName})
  }

  return (
    <div
      className={`form-input ${className} ${required ? 'form-required' : ''} ${isError && isTouched ? 'error' : ''} ${isValid && isTouched ? 'valid' : ''}`}>
      <label htmlFor={inputName}>{label}</label>
      <div className="form-input__wrapper">
        <IMaskInput
          mask={mask}
          type={inputType}
          name={inputName}
          id={inputName}
          className={`form-text card-${inputName}`}
          placeholder={placeholder}
          autoComplete="off"
          value={value}
          onAccept={onInputAccept}
          onChange={onInputChange}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          maxLength={maxLengthHandler}
          readOnly={readOnlyHandler}
        />
        {isError && isTouched && (
          <span className="invalid-icon form-input__status-icon"/>
        )}
        {isValid && isTouched && (
          <span className="valid-icon form-input__status-icon"/>
        )}
      </div>
      {isError && isTouched && (
        <p className="error-message expiry">{required}</p>
      )}
    </div>
  );
};

export default InputField;

InputField.propTypes = {
  state: PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.string,
    expiry: PropTypes.string,
    cvc: PropTypes.string,
    issuer: PropTypes.string,
    focused: PropTypes.string,
    requireFields: PropTypes.arrayOf(PropTypes.string),
    validFields: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  paymentMethods: PropTypes.shape({}),
  inputName: PropTypes.string,
  required: PropTypes.string,
  inputType: PropTypes.string.isRequired,
  payment: PropTypes.shape({}),
};

InputField.defaultProps = {
  paymentMethods: {},
  inputName: '',
  required: 'This field is required!',
  payment: {},
};
